import { Component } from '@angular/core';

@Component({
    selector: 'app-auth',
    imports: [],
    template: '',
})
export class AuthComponent {}
